import { Link } from "react-router-dom";
import { PROCESS_STEPS } from "@/mocks/content";
import { Eyebrow } from "@/components/ui/primitives";

export default function Process() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-12 max-w-2xl">
          <Eyebrow text="创作过程" en="Process" />
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            一部小电影，是这样从零长出来的
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            幕后之所以动人，是因为它把每一次放弃与坚持都摊开在镜头前。顺着五步，看看一部短片真正经历过的路。
          </p>
        </div>

        <ol className="relative grid gap-5 md:grid-cols-5 md:gap-4">
          <span className="absolute left-0 right-0 top-7 hidden h-px bg-background-300 md:block" aria-hidden="true" />
          {PROCESS_STEPS.map((s) => (
            <li key={s.step} className="relative flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:block">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-primary-400/50 bg-background-100 font-display text-lg text-primary-300 md:mx-auto md:h-14 md:w-14">
                {s.step}
              </div>
              <div className="mt-0 md:mt-4 md:text-center">
                <span className="font-display text-[11px] uppercase tracking-[0.2em] text-primary-600">{s.en}</span>
                <h3 className="mt-1 font-heading text-lg font-semibold text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-10 flex justify-center">
          <Link
            to="/column?c=process"
            className="inline-flex items-center gap-2 rounded-full border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-900 transition hover:border-primary-400 hover:text-primary-200"
          >
            读完整创作过程复盘 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}